/* eslint-disable */ 
import * as Yup from "yup";  
const numbersOnly = (value) => /^[0-9]*$/.test(value)  
//const alphaNUmericsOnly = (value) => /^[a-zA-Z0-9 ]*$/.test(value)
const emailsOnly = (value) => /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/.test(value)

export const FormValidationSchema = Yup.object().shape({ 
     
    accountNumber: Yup.string().min(13, `Account Number has to be at least 13 numbers long` )
    .max(13, `You can't exceed 13 numbers for Account Number.`).required('Account Number is required')
    .test('Digits only', 'Account Number should have numbers only', numbersOnly),
    accountName: Yup.string().max(45).required('Account Name is required'),
    
    //emailAddress: Yup.string().max(45).test('email', 'Only valid Emails are allowed, check your format', emailsOnly),
    emailAddress: Yup.string().email().nullable(),
    requestDate: Yup.date().required('Request date is required'),
    //branchOfApplication: Yup.string().max(10).required('Branch is required'),
    //mobilePhoneNumber: Yup.string().max(9).required('Phone Number is a required field').min(9).max(9).test('Digits only', 'Mobile Phone should have numbers only', numbersOnly),
    countryCode:Yup.string().max(10).required('Country Code is required'),
    mobilePhoneNumber: Yup.string()
      //.matches(/^7/, 'Mobile Phone should start with 7')
      //.max(9, 'Phone Number should be 9 digits')
      //.min(9, 'Phone Number should be 9 digits')
      .required('Phone Number is a required field')
      .test('Digits only', 'Mobile Phone should have numbers only', numbersOnly),
    timeOfRequest: Yup.string().required('Time of request is required'),
    policy: Yup.bool().oneOf([true], 'You need to accept the terms and conditions'),  
    idType: Yup.string().required('Please Choose an ID type'),
    
    //idNumber: Yup.string().max(25).required('ID Number is a required field').min(5),
    idNumber: Yup.string().when('idType', {
      is: (idType) => ['Passport', 'Refugee ID', 'National ID'].includes(idType),
      then: Yup.string().when('idType', {
        is: 'Passport',
        then: Yup.string()
          .min(5, 'Passport should not have less than 5 characters, you have entered less')
          .max(25, 'Passport should not have more than 25 characters, you have entered more')
          .required('Enter your Passport ID Number'),
      }).when('idType', {
        is: 'Refugee ID',
        then: Yup.string()
          .min(5, 'Refugee ID should not have less than 5 characters, you have entered less')
          .max(25, 'Refugee ID should not have more than 25 characters, you have entered more')
          .required('Enter your Refugee ID Number'),
      }).when('idType', {
        is: 'National ID',
        then: Yup.string()
          //.matches(/^(CM|CF|RM|PM)/, 'National ID should start with either CM or CF or RM or PM')
          .min(14, 'National ID should have exactly 14 characters')
          .max(14, 'National ID should have exactly 14 characters')
          .required('Enter your National ID Number'),
      }),
    }),
    

    /*frontImageValueHolder:Yup.string().when('idType',{
      is: (value) => !!value, // Only validate when parentSelection has a value
        then: Yup.string().required('Please attach a front face ID photo'),
    }),
    backImageValueHolder:Yup.string().when('idType',{
      is: (value) => !!value, // Only validate when parentSelection has a value
        then: Yup.string().required('Please attach a back face ID photo'),
    }),*/
    
    signatureImageValueHolder:Yup.string().when('idType',{
      is: (value) => !!value, // Only validate when parentSelection has a value
        then: Yup.string().required('Please attach your signature photo'),
    }),
    /*digitalSignatureValueHolder:Yup.string().when('idType',{
      is: (value) => !!value, // Only validate when parentSelection has a value
        then: Yup.string().required('Your Signature is required'),
    }),*/
    //stopPaymentReason: Yup.string().required(''), 
    //chequeNumberRange: Yup.string().required('Cheque Number range is required')
    //Adding the logic for the parent child selections @Stop Payment
    chequeNumberRange: Yup.string(),
    /*stoppaymenttime: Yup.string().when('chequeNumberRange', {
        is: (value) => !!value, // Only validate when parentSelection has a value
        then: Yup.string().required('Time to Stop payment is required because you selected Cheque Number or range'),
    }),*/
    stoppaymenttime: Yup.string().test('clearChildData', 'Time to Stop payment is required because you selected Cheque Number or range', function(value) {
      const parentSelection = this.parent.chequeNumberRange; 
      // Check if parent field is unselected or doesn't have a value
      if (!parentSelection) {
        // Clear child data
        this.parent.stoppaymenttime = '';       
        // Return true to indicate the validation passed
        return true;
      }      
      // Check if child field is empty when the parent is selected
      if (parentSelection && !value) {
        return false;
      }      
      return true;
    }),

    stopPaymentReason: Yup.string().test('clearChildData', 'The reason to stop the payment is required because you selected Cheque Number or range', function(value) {
      const parentSelection = this.parent.chequeNumberRange; 
      // Check if parent field is unselected or doesn't have a value
      if (!parentSelection) {
        // Clear child data
        this.parent.stopPaymentReason = '';       
        // Return true to indicate the validation passed
        return true;
      }      
      // Check if child field is empty when the parent is selected
      if (parentSelection && !value) {
        return false;
      }      
      return true;
    }),

    //branchOfApplication: Yup.string().max(10).required('Branch is required'),
    //backImageValueHolder:Yup.string().required('Please attach a Back face ID photo'),
    //numberOfChequeBooksUGX: Yup.number(),
    branchOfApplication: Yup.string().when(['numberOfChequeBooksUGX','numberOfChequeBooksKES','numberOfChequeBooksUSD','numberOfChequeBooksEUR','numberOfChequeBooksGBP', 'postbankDebitCard'], {
      is: (numberOfChequeBooksKES, numberOfChequeBooksUGX,numberOfChequeBooksUSD,numberOfChequeBooksEUR,numberOfChequeBooksGBP,postbankDebitCard) =>
      !!numberOfChequeBooksKES || !!numberOfChequeBooksUGX || !!numberOfChequeBooksUSD || !!numberOfChequeBooksEUR || !!numberOfChequeBooksGBP || !!postbankDebitCard,
    then: Yup.string().required(
      'Branch is required because you have either requested (cheque books OR PostBank Debit Card Replacement) and we need to know your pickup point of convenience'
    ),
    otherwise: Yup.string(),
    }),
    //Validate the digitalSignature
    //digitalSignatureValueHolder:Yup.string().required('Digital Signature is required'),
    digitalServices:Yup.string().max(45).required('Please select a service to proceed.'),
    
    //Validating the number of Postbank debit Card.
    postbankDebitCard: Yup.string().test('clearChildData', 'PostBank Debit Card service under Digital Banking is required', function(value) {
      const parentSelection = this.parent.digitalServices; 
      // Check if parent field is unselected or doesn't have a value
      if (!parentSelection || parentSelection!='PostBank Debit Card Replacement') {
        // Clear child data
        this.parent.postbankDebitCard = '';       
        // Return true to indicate the validation passed
        return true;
      }      
      // Check if child field is empty when the parent is selected
      if (parentSelection && !value) {
        return false;
      }      
      return true;
    }),

    //Validating the number of Block ATM Card.
    blockATMCardReason: Yup.string().test('clearChildData', 'Block ATM Card under Digital Banking is required', function(value) {
      const parentSelection = this.parent.digitalServices; 
      // Check if parent field is unselected or doesn't have a value
      if (!parentSelection || parentSelection!='Block My ATM Card') {
        // Clear child data
        this.parent.blockATMCardReason = null;       
        // Return true to indicate the validation passed
        return true;
      }      
      // Check if child field is empty when the parent is selected
      if (parentSelection && !value) {
        return false;
      }      
      return true;
    }),

    postOnline: Yup.string().test('clearChildData', 'Post Online service under Digital Banking is required', function(value) {
      const parentSelection = this.parent.digitalServices; 
      // Check if parent field is unselected or doesn't have a value
      if (!parentSelection || parentSelection!='PostOnline Services') {
        // Clear child data
        this.parent.postOnline = "";       
        // Return true to indicate the validation passed
        return true;
      }      
      // Check if child field is empty when the parent is selected
      if (parentSelection && !value) {
        return false;
      }      
      return true;
    }),

    limitAmount: Yup.string().test('clearChildData', 'ATM Card Limit under Digital Banking is required', function(value) {
      const parentSelection = this.parent.digitalServices; 
      // Check if parent field is unselected or doesn't have a value
      if (!parentSelection || parentSelection!='ATM Card Limit Enhancement') {
        // Clear child data
        this.parent.limitAmount = "";       
        // Return true to indicate the validation passed
        return true;
      }      
      // Check if child field is empty when the parent is selected
      if (parentSelection && !value) {
        return false;
      }      
      return true;
    }),

    postMobile: Yup.array().test('postMobileValidation', 'At least one option under Post Mobile must be selected.', function (value) {
      const { digitalServices } = this.parent;
      const isPostMobileSelected = value && value.length > 0;
      
      // If the parent field digitalServices is "PostMobile" and no options are selected, validation fails
      if (digitalServices === 'Post Mobile Services' && !isPostMobileSelected) {
        return false;
      }

      return true; // Validation passed
    }),

    //For Cheque books
    numberOfChequeBooksUGX: Yup.string().test('clearChildData', 'Number Of Leaves UGX under cheque books services is required', function(value) {
      const parentSelection = this.parent.digitalServices; 
      // Check if parent field is unselected or doesn't have a value
      if (!parentSelection || parentSelection!='ChequeBooks UGX') {
        // Clear child data
        this.parent.numberOfChequeBooksUGX = "";       
        // Return true to indicate the validation passed
        return true;
      }      
      // Check if child field is empty when the parent is selected
      if (parentSelection && !value) {
        return false;
      }      
      return true;
    }),

    numberOfChequeBooksKES: Yup.string().test('clearChildData', 'Number Of Leaves KES under cheque books services is required', function(value) {
      const parentSelection = this.parent.digitalServices; 
      // Check if parent field is unselected or doesn't have a value
      if (!parentSelection || parentSelection!='ChequeBooks KES') {
        // Clear child data
        this.parent.numberOfChequeBooksKES = "";       
        // Return true to indicate the validation passed
        return true;
      }      
      // Check if child field is empty when the parent is selected
      if (parentSelection && !value) {
        return false;
      }      
      return true;
    }),

    numberOfChequeBooksUSD: Yup.string().test('clearChildData', 'Number Of Leaves USD under cheque books services is required', function(value) {
      const parentSelection = this.parent.digitalServices; 
      // Check if parent field is unselected or doesn't have a value
      if (!parentSelection || parentSelection!='ChequeBooks USD') {
        // Clear child data
        this.parent.numberOfChequeBooksUSD = "";       
        // Return true to indicate the validation passed
        return true;
      }      
      // Check if child field is empty when the parent is selected
      if (parentSelection && !value) {
        return false;
      }      
      return true;
    }),

    numberOfChequeBooksEUR: Yup.string().test('clearChildData', 'Number Of Leaves EUR under cheque books services is required', function(value) {
      const parentSelection = this.parent.digitalServices; 
      // Check if parent field is unselected or doesn't have a value
      if (!parentSelection || parentSelection!='ChequeBooks EUR') {
        // Clear child data
        this.parent.numberOfChequeBooksEUR = "";       
        // Return true to indicate the validation passed
        return true;
      }      
      // Check if child field is empty when the parent is selected
      if (parentSelection && !value) {
        return false;
      }      
      return true;
    }),
    numberOfChequeBooksGBP: Yup.string().test('clearChildData', 'Number Of Leaves GBP under cheque books services is required', function(value) {
      const parentSelection = this.parent.digitalServices; 
      // Check if parent field is unselected or doesn't have a value
      if (!parentSelection || parentSelection!='ChequeBooks GBP') {
        // Clear child data
        this.parent.numberOfChequeBooksGBP = "";       
        // Return true to indicate the validation passed
        return true;
      }      
      // Check if child field is empty when the parent is selected
      if (parentSelection && !value) {
        return false;
      }      
      return true;
    }),
});